import(/* webpackMode: "eager", webpackExports: ["PaymentContent"] */ "/var/www/azia_frontv2_green/src/app/payment/payment-content.tsx");
